module.exports = __webpack_public_path__ + "img/logo_w.d9950439.png";